import React from 'react';
import MyBetsLayout2 from './my-bets-layout-2/MyBetsLayout2';
import { getConfiguration } from '../utils';
import MyBetsLayout1 from './MyBetsLayout1';
import MyBetsLayout3 from './my-bets-layout-3/MyBetsLayout3';
import SeoMetaTags from '../seo/SeoMetaTags';
import { SeoContext } from '../seo/SeoContextProvider';
import { useFetchSeoSettings } from '../fetchSeoSettings';
import { useHandleSeoSettings } from '../seo/seoUtils';
import { xs_isMobile } from '../..';

function MyBetsSeoMetatag(props) {
	const conf = getConfiguration();
	const seoContext = React.useContext(SeoContext);
	const [seoSettingsState] = useFetchSeoSettings(seoContext && seoContext.pathname,xs_isMobile,conf.seo);
		
	useHandleSeoSettings(seoSettingsState);

	return (
		<SeoMetaTags />
	)

}


function MyBets(props) {
	const conf = getConfiguration();
	const layoutVersion = conf.mbt ?? 'V1';
	
	let LayoutComponent;

	switch (layoutVersion) {
		case 'V1':
			LayoutComponent = MyBetsLayout1;
			break;
		case 'V2':
			LayoutComponent = MyBetsLayout2;
			break;
		case 'V3':
			LayoutComponent = MyBetsLayout3;
			break;
		default:
			LayoutComponent = MyBetsLayout1;
	}

	return (
		<>
			{!xs_isMobile && <MyBetsSeoMetatag /> /* On mobile the <SeoMetaTags> component is rendered inside the <Shell> component  */}
			<LayoutComponent {...props} />
		</>
	);

}

export default MyBets;